import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';

import AcceptTransferModal from './components/AcceptTransferModal';
import DeclineTransferModal from './components/DeclineTransferModal';

function TransferBookingModals() {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route path={`${path}/accept`} component={AcceptTransferModal} />
      <Route path={`${path}/decline`} component={DeclineTransferModal} />
    </Switch>
  );
}

export default TransferBookingModals;
